
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mp",
      function () {
        return require("private-next-pages/mp/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mp"])
      });
    }
  